import { Dialog } from '@servicetitan/design-system';
import { ConfirmationProps } from '@servicetitan/confirm';

export const CustomConfirmCancel = ({ title, message, onConfirm, onCancel }: ConfirmationProps) => {
    return (
        <Dialog
            open
            negative
            primaryActionName="Yes, Cancel"
            secondaryActionName="Go back"
            title={title}
            onPrimaryActionClick={onConfirm}
            onSecondaryActionClick={onCancel}
        >
            {message}
        </Dialog>
    );
};
